import { render, staticRenderFns } from "./BaseButtonIcon.vue?vue&type=template&id=371723e4"
import script from "./BaseButtonIcon.vue?vue&type=script&lang=js"
export * from "./BaseButtonIcon.vue?vue&type=script&lang=js"
import style0 from "./BaseButtonIcon.vue?vue&type=style&index=0&id=371723e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports